import React, { useEffect, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';

import './scss/app-cover.scss';
import Color from '@/tool/color';
import AppPortal from './app-portal';

interface IProps {
  children: ReactNode,
}
interface IState {}

const AppCover = (props: IProps, state: IState) => {
  const location = useLocation();
  const navi = useNavigate();
  const { children } = props;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <AppPortal>
      <section className="app-cover">{children}</section>
    </AppPortal>
  );
};

export default observer(AppCover);
